// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zFve","type":"styles_type__1z6ID","choices":"styles_choices__11ht-"};